import React, { useState, useEffect } from "react";
import { getChange } from "./Utilities/api";
import HistoryIcon from "@mui/icons-material/History";
import { PageHeader, PageShell } from "../../components/UI/Page";
import { LoadingState } from "../../components/UI/States";

const ChangeLog = () => {
  const [changeEntries, setChangeEntries] = useState([]);

  useEffect(() => {
    getChange(setChangeEntries);
  }, []);

  // const groupedChanges = changeEntries.reduce((grouped, entry) => {
  //   const date = new Date(entry.date).toLocaleDateString();
  //   grouped[date] = [...(grouped[date] || []), entry];
  //   return grouped;
  // }, {});
  const groupedChanges = {};
  changeEntries.forEach((entry) => {
    const date = new Date(entry.date).toLocaleDateString();
    groupedChanges[date] = [...(groupedChanges[date] || []), entry];
  });

  return (
    <PageShell size="md">
      <PageHeader
        icon={HistoryIcon}
        tone="slate"
        eyebrow="Admin"
        title="Changelog"
      />
      {changeEntries.length > 0 ? (
        <div className="space-y-4">
          {Object.entries(groupedChanges).map(([date, entries], index) => (
            <section key={index} className="app-card rounded-2xl border p-5">
              <h2 className="text-lg font-semibold tabular-nums">{date}</h2>
              <ul className="mt-3 space-y-2">
                {entries.map((entry, subIndex) => (
                  <li key={subIndex} className="flex items-start gap-3 text-sm">
                    <span
                      aria-hidden="true"
                      className="mt-[0.45rem] h-1.5 w-1.5 shrink-0 rounded-full bg-sky-500"
                    />
                    <span className="min-w-0 break-words leading-relaxed">
                      {entry.change}
                    </span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      ) : (
        <LoadingState label="Loading changelog…" />
      )}
    </PageShell>
  );
};

export default ChangeLog;
